var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0113 0.055542H2.65577C2.11355 0.055542 1.59354 0.270938 1.21013 0.654346C0.826724 1.03775 0.611328 1.55777 0.611328 2.09999V20.5L4.70022 16.4111H19.0113C19.5535 16.4111 20.0736 16.1957 20.457 15.8123C20.8404 15.4289 21.0558 14.9089 21.0558 14.3667V2.09999C21.0558 1.55777 20.8404 1.03775 20.457 0.654346C20.0736 0.270938 19.5535 0.055542 19.0113 0.055542Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotIcon);
export default __webpack_public_path__ + "static/media/chatbot-icon.8db637e2c4c2a12ca7b17e39fc88dd0a.svg";
export { ForwardRef as ReactComponent };